<template>
  <div v-if="question" class="brand-question-wrapper">
    <div class="question-title">
      <h2 class="question-choice">{{ question.intro }}</h2>
      <div class="question-intro"  v-if="question.diagnosis.answers[1][0].answer !== 'schmuck'">
        <strong
          >Bitte beantworten Sie die Fragen zur Eingrenzung des Schadens und der
          Ermittlung der Service-Leistungen.</strong
        >
        <br />
        Bitte beachten Sie, dass hier ausschließlich
        Service-Fälle für Lieferadressen in Deutschland entgegengenommen werden.<br />
        Servicegutscheine bzw. Batteriegutscheine können nur in einer Filiale
        eingelöst werden, nicht im Online-Uhren&Schmuck-Service.
      </div>
      
        <div v-else class="grid-question-options">
          <grid-option-list :option-list="optionList" />
        </div>
    </div>
    <div class="content-wrapper">
      <div>
        <div
          v-if="question.diagnosis.answers[1][0].answer !== 'schmuck'"
          class="brand-search"
        >
          <div class="brand-search-top">
            <h2 class="mobile-text small-margin-bottom">
              <strong>Alle Marken</strong>
            </h2>
            <h2 class="tablet-text small-margin-bottom">
              <strong>Alle Marken</strong>
            </h2>
            <div class="search">
              <input
                v-model="searchQuery"
                type="text"
                class="search-bar"
                placeholder="Marke"
                v-on:keydown.enter.prevent='submit'
                v-on:keydown.enter='updateVModel(searchQuery)'
              />
              <b-button
                variant="dark"
                class="search-button"
                v-on:click="updateVModel(searchQuery)"
              >
                <img src="../../assets/images/diagnosis/search.svg" />
              </b-button>
            </div>
          </div>
          <br />
          <div>
            <div class="letter-search">
              <div v-for="alpha in alphabet" :key="alpha" class="letter">
                <b-button
                  value="alpha"
                  :id="'letterbrand' + alpha"
                  @click="updateOverButtons(alpha)"
                  >{{ alpha }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <grid-option-list  v-if="question.diagnosis.answers[1][0].answer !== 'schmuck'" :option-list="optionList" />
    <p v-if="optionList.length === 0">
      Es konnte leider keine Marke gefunden werden
    </p>
  </div>
</template>

<script>
import GridOptionList from "../diagnosis/GridOptionList";

export default {
  name: "BrandQuestion",
  components: {
    GridOptionList,
  },
  data() {
    return {
      openedModal: null,
      search: "A",
      searchQuery: "",
      options: this.$store.state.questions[0].config.options,
      alphabet: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      notToDisable: [],
      toDisable: [],
    };
  },
  mounted() {
    this.disableSearchButtons();
  },
  computed: {
    optionList() {
      const options = this.filter(this.options);
      return options;
    },
    question: function () {
      return this.$store.state.questions[0] || false;
    },
  },
  methods: {
    disableSearchButtons() {
      if (this.question.diagnosis.answers[1][0].answer !== "schmuck") {
        this.alphabet.forEach((letter) => {
          this.options.forEach((option) => {
            if (
              option.title.startsWith(letter) &&
              !this.notToDisable.includes(letter)
            ) {
              this.notToDisable.push(letter);
            }
          });
        });
        this.alphabet.forEach((letter) => {
          if (!this.notToDisable.includes(letter)) {
            this.toDisable.push(letter);
            document.getElementById("letterbrand" + letter).disabled = "true";
          }
        });
        this.search = this.notToDisable[0];
        document.getElementById(
          "letterbrand" + this.notToDisable[0]
        ).style.color = "white";
        document.getElementById(
          "letterbrand" + this.notToDisable[0]
        ).style.background = "#1a1a1a";
      }
    },
    filter(toFilter) {
      if (this.question.diagnosis.answers[1][0].answer !== "schmuck") {
        const options = toFilter.filter((option) => {
          let bool1 = option.title
            .toLowerCase()
            .startsWith(this.search.toLowerCase());
          let lowerCaseArray = option.synonyms.map((entry) =>
            entry.toLowerCase()
          );
          let bool2 =
            lowerCaseArray.filter((element) =>
              element.startsWith(this.search.toLowerCase())
            ).length > 0;
          if (bool1 || bool2) return option;
        });
        return options;
      } else {
        return toFilter;
      }
    },
    updateVModel(text) {
      if (this.notToDisable.includes(text)) {
        this.updateOverButtons(text);
      } else {
        this.search = text;
        this.notToDisable.forEach((item) => {
          document.getElementById("letterbrand" + item).style.color = "#1a1a1a";
          document.getElementById("letterbrand" + item).style.background =
            "transparent";
        });
      }
    },
    updateOverButtons(text) {
      this.search = text;
      this.searchQuery = "";
      this.notToDisable.forEach((item) => {
        document.getElementById("letterbrand" + item).style.color = "#1a1a1a";
        document.getElementById("letterbrand" + item).style.background =
          "transparent";
      });
      document.getElementById("letterbrand" + text).style.color = "white";
      document.getElementById("letterbrand" + text).style.background =
        "#1a1a1a";
    },
  },
};
</script>
